(function () {
  'use strict';

  var ENDPOINT = 'https://chatty-lemming-87.convex.cloud/api/query';
  var QUERY_PATH = 'queries:publicTrackingStatus';

  // Backend status → stepper index. AVAILABLE_FOR_PICKUP and UNSUCCESSFUL_DELIVERY
  // share stage 4 with OUT_FOR_DELIVERY because they're all "courier holds it,
  // not delivered" — the title/lede differentiate them visually.
  var STAGE_INDEX = {
    PROCESSING: 0,
    DISPATCHED: 1,
    EN_ROUTE: 2,
    ARRIVED_COURIER_FACILITY: 3,
    OUT_FOR_DELIVERY: 4,
    AVAILABLE_FOR_PICKUP: 4,
    UNSUCCESSFUL_DELIVERY: 4,
    DELIVERED: 5
  };
  var TOTAL_STEPS = 6;

  function init(root) {
    var configEl = root.querySelector('[data-cl-config]');
    var config = {};
    if (configEl) {
      try { config = JSON.parse(configEl.textContent); } catch (_) { config = {}; }
    }
    config.errors = config.errors || {};
    config.statusCopy = config.statusCopy || {};

    var form          = root.querySelector('[data-cl-form]');
    var input         = root.querySelector('[data-cl-input]');
    var submitBtn     = root.querySelector('[data-cl-submit]');
    var errorEl       = root.querySelector('[data-cl-error]');
    var resultEl      = root.querySelector('[data-cl-result]');
    var cardEl        = root.querySelector('[data-cl-card]');
    var titleEl       = root.querySelector('[data-cl-title]');
    var ledeEl        = root.querySelector('[data-cl-lede]');
    var updatedEl     = root.querySelector('[data-cl-updated]');
    var progressBar   = root.querySelector('[data-cl-progress]');
    var stepEls       = root.querySelectorAll('[data-cl-step]');
    var pillEl        = root.querySelector('[data-cl-pill]');
    var copyBtn       = root.querySelector('[data-cl-copy]');
    var copyIcon      = root.querySelector('[data-cl-copy-icon]');
    var copyCheck     = root.querySelector('[data-cl-copy-check]');
    var toastEl       = root.querySelector('[data-cl-toast]');
    var trackAnother  = root.querySelector('[data-cl-track-another]');

    if (!form || !input || !resultEl) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var copyResetTimer = null;
    var toastTimer = null;
    var inFlight = false;

    function showError(msg) {
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    function clearError() {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function setLoading(on) {
      inFlight = !!on;
      submitBtn.disabled = !!on;
      submitBtn.classList.toggle('is-loading', !!on);
    }

    function showToast(text) {
      if (!toastEl || !text) return;
      toastEl.textContent = text;
      toastEl.classList.add('show');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.classList.remove('show');
      }, 1800);
    }

    function applyStepperState(idx) {
      for (var i = 0; i < stepEls.length; i++) {
        var step = stepEls[i];
        step.classList.remove('done', 'current');
        step.removeAttribute('aria-current');
        if (i < idx) {
          step.classList.add('done');
        } else if (i === idx) {
          step.classList.add('current');
          step.setAttribute('aria-current', 'step');
        }
      }
      if (!progressBar) return;
      // Mirror the design's Stepper math: the track sits between dot 1 and dot N,
      // so the bar width grows by 1/(TOTAL_STEPS-1) per completed stage and the
      // track itself is shorter than the container by one cell on each side.
      var pct = Math.max(0, Math.min(TOTAL_STEPS - 1, idx)) / (TOTAL_STEPS - 1);
      progressBar.style.width = 'calc((100% - (100% / ' + TOTAL_STEPS + ')) * ' + pct + ')';
      progressBar.style.transform = 'scaleX(1)';
    }

    function resetStepper() {
      for (var i = 0; i < stepEls.length; i++) {
        stepEls[i].classList.remove('done', 'current');
        stepEls[i].removeAttribute('aria-current');
      }
      if (progressBar) {
        progressBar.style.transform = 'scaleX(0)';
        progressBar.style.width = '0';
      }
    }

    function scrollToResult() {
      if (reducedMotion) {
        resultEl.scrollIntoView({ block: 'start' });
        return;
      }
      var top = resultEl.getBoundingClientRect().top + window.scrollY - 24;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function replayReveal() {
      // Toggling the trigger class and forcing a reflow restarts the keyframe
      // animations on the result card's children (eyebrow → pill row).
      cardEl.classList.remove('cl-result-card-animated');
      // eslint-disable-next-line no-unused-expressions
      void cardEl.offsetWidth;
      cardEl.classList.add('cl-result-card-animated');
    }

    function renderResult(value) {
      var status = value && value.status;
      var copy = config.statusCopy[status] || { title: status || '', lede: '' };

      titleEl.textContent = copy.title || '';
      ledeEl.textContent = copy.lede || '';

      if (value && value.lastUpdateAt) {
        try {
          var d = new Date(value.lastUpdateAt);
          updatedEl.textContent = (config.lastUpdateLabel || 'Last update:') + ' ' + d.toLocaleString();
        } catch (_) {
          updatedEl.textContent = '';
        }
      } else {
        updatedEl.textContent = '';
      }

      pillEl.textContent = input.value;

      var idx = STAGE_INDEX[status];
      if (typeof idx !== 'number') idx = 0;

      resetStepper();
      replayReveal();
      resultEl.hidden = false;

      // Two rAFs ensure the [hidden] → visible transition has a starting frame
      // for max-height/opacity before .open kicks in.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          resultEl.classList.add('open');
          applyStepperState(idx);
        });
      });

      setTimeout(function () {
        scrollToResult();
        try { titleEl.focus({ preventScroll: true }); } catch (_) { titleEl.focus(); }
      }, 320);
    }

    function lookup(code) {
      clearError();
      setLoading(true);
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          path: QUERY_PATH,
          args: { trackingNumber: code },
          format: 'json'
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('http');
          return res.json();
        })
        .then(function (json) {
          if (!json || !json.value || !json.value.found) {
            showError(config.errors.notFound);
            setLoading(false);
            return;
          }
          renderResult(json.value);
          setLoading(false);
        })
        .catch(function () {
          showError(config.errors.network);
          setLoading(false);
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (inFlight) return;
      var code = (input.value || '').trim().toUpperCase();
      input.value = code;
      if (code.length < 6) {
        showError(config.errors.invalid);
        return;
      }
      lookup(code);
    });

    // Re-validate on input so the inline error doesn't linger after the user fixes it.
    input.addEventListener('input', function () {
      if (!errorEl.hidden) clearError();
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var value = (pillEl.textContent || '').trim();
        if (!value) return;
        var done = function () {
          copyBtn.classList.add('copied');
          if (copyIcon) copyIcon.hidden = true;
          if (copyCheck) copyCheck.hidden = false;
          showToast(config.copyToast);
          if (copyResetTimer) clearTimeout(copyResetTimer);
          copyResetTimer = setTimeout(function () {
            copyBtn.classList.remove('copied');
            if (copyIcon) copyIcon.hidden = false;
            if (copyCheck) copyCheck.hidden = true;
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(done).catch(function () { done(); });
        } else {
          done();
        }
      });
    }

    if (trackAnother) {
      trackAnother.addEventListener('click', function () {
        resultEl.classList.remove('open');
        clearError();
        input.value = '';
        resetStepper();
        var onEnd = function (e) {
          if (e.propertyName && e.propertyName !== 'max-height') return;
          resultEl.hidden = true;
          resultEl.removeEventListener('transitionend', onEnd);
        };
        resultEl.addEventListener('transitionend', onEnd);
        // Fallback in case transitionend doesn't fire (reduced motion / no transition).
        setTimeout(function () {
          if (resultEl.classList.contains('open')) return;
          resultEl.hidden = true;
        }, 1000);

        if (reducedMotion) {
          window.scrollTo({ top: 0 });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        try { input.focus({ preventScroll: true }); } catch (_) { input.focus(); }
      });
    }

    // URL ?code=… auto-lookup on first paint. Uses requestSubmit so the submit
    // handler runs the same path as a manual click — no duplicated logic.
    var params = new URLSearchParams(window.location.search);
    var codeFromUrl = params.get('code');
    if (codeFromUrl) {
      input.value = codeFromUrl.trim().toUpperCase();
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-cl-tracking]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].dataset.clInitialized === '1') continue;
      roots[i].dataset.clInitialized = '1';
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when Shopify theme editor re-renders the section
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector('[data-cl-tracking]')
      : null;
    if (root && root.dataset.clInitialized !== '1') {
      root.dataset.clInitialized = '1';
      init(root);
    }
  });
})();
